<template>
	<div class="page">
		<Breadcrumb :pathList="pathList"></Breadcrumb>
		<div class="cont">
			<div class="vipBg flex-column-item">
				<img :src="detail.img" style="width: 64px;height: auto;" alt="" />
				<div class="name">{{detail.name}}</div>
				<div class="pr" v-if="loginUser.member.uuid !=detail.uuid">
					<span>{{payType==2?'¥'+ vipPrice:detail.score-loginUser.member.score}}</span>/年
				</div>
				<div class="pr" v-if="loginUser.member.uuid ==detail.uuid">
					<span>{{payType==2?'¥'+ detail.price:detail.score}}</span>/年
				</div>
			</div>
			<div class="wbox">
				<div class="tit">支付方式</div>
				<div class="gbox">
					<div class="flex flex-b botl">
						<div class="flex">
							<img src="../../assets/images/icon/iwx.png"
								style="width: 27px;height: 27px;margin-right: 20px;" alt="" />
							<div class="t1">微信支付</div>
						</div>
						<img src="../../assets/icon/xz.png" v-if="payType==2" class="pointer"
							style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
						<img src="../../assets/icon/wxz.png" @click="payType=2" v-else class="pointer"
							style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
					</div>
					<div class="flex flex-b botl">
						<div class="flex">
							<img src="../../assets/images/icon/ijf.png"
								style="width: 27px;height: 27px;margin-right: 20px;" alt="" />
							<div class="t1">积分支付（可用：<img src="../../assets/images/icon/jb.png"
									style="width: 22px;height: 22px;" alt="" />{{loginUser.score}}）</div>
						</div>
						<img src="../../assets/icon/xz.png" v-if="payType==1" class="pointer"
							style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
						<img src="../../assets/icon/wxz.png" @click="payType=1" v-else class="pointer"
							style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
					</div>
				</div>
				<div class="flex flex-b mt10">
					<div class="t">支付费用</div>
					<div class="t2" v-if="payType==2">¥{{detail.price}}</div>
					<div class="t2" v-else>{{detail.score}}<span>积分</span></div>
				</div>
				<div class="flex flex-b mt10">
					<div class="t">已有会员等级</div>
					<div class="t2 gold">{{loginUser.member.name}}</div>
				</div>
				<!-- <div class="flex flex-b mt10">
					<div class="t">抵扣优惠</div>
					<div class="t2">{{loginUser.member.discount||0}}<span>积分</span></div>
				</div> -->
				<div class="flex flex-b" style="border-top: 1px solid #EEEEEE;padding-top: 10px;margin-top: 10px;">
					<div class="t" style="font-weight: 600;">实付</div>
					<div v-if="loginUser.member.uuid ==detail.uuid">
						<div class="price" v-if="payType==2">¥{{detail.price}}</div>
						<div class="price" v-else>{{detail.score-parseFloat(loginUser.discount||0)}}<span>积分</span>
						</div>
					</div>
					<div v-if="loginUser.member.uuid !=detail.uuid">
						<div class="price" v-if="payType==2">¥{{vipPrice}}</div>
						<div class="price" v-else>{{detail.score-loginUser.member.score}}<span>积分</span></div>
					</div>
				</div>
			</div>
			<div class="flex" style="margin-top: 180px;">
				<img src="../../assets/icon/wxz.png" v-if="!selectRule" @click="selectRule=!selectRule" class="pointer"
					style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
				<img src="../../assets/icon/xz.png" v-else @click="selectRule=!selectRule" class="pointer"
					style="width: 18px;height: 18px;margin-right: 20px;" alt="" />
				<div class="tip">我已阅读并同意以下内容<span class="pointer">报名须知</span>以及<span class="pointer">合同条款</span></div>
			</div>
		</div>
		<div class="bottomFixed flex flex-b">
			<!-- <div class="price" v-if="payType==2">¥{{detail.price}}</div>
			<div class="price" v-if="payType==1">{{detail.score-parseFloat(loginUser.discount||0)}}</div> -->

			<div v-if="loginUser.member.uuid ==detail.uuid">
				<div class="price" v-if="payType==2">¥{{detail.price}}</div>
				<div class="price" v-else>{{detail.score-parseFloat(loginUser.discount||0)}}<span>积分</span></div>
			</div>
			<div v-if="loginUser.member.uuid !=detail.uuid">
				<div class="price" v-if="payType==2">¥{{vipPrice}}</div>
				<div class="price" v-else>{{detail.score-loginUser.member.score}}<span>积分</span></div>
			</div>
			<div class="login-btn pointer" @click="buyClick"><span class="text">立即购买</span></div>
		</div>
		<el-dialog :visible.sync="wxPay" width="500" center :show-close="true" title="微信支付">
			<div class="dialog flex-column-item">
				<div class="money">应付金额：<span>¥1</span></div>
				<div class="subTime">剩余支付时间<span>29分59秒</span>，超时请重新发起订单</div>
				<div class="ewm"></div>
				<div class="tt">请使用微信扫码支付</div>
				<div class="wxbtn pointer" style="width: 156px;height: 46px;" @click="wxPay=false">我已支付</div>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="showShare" width="438px" center :show-close="false">
			<div class="shareBg flex-column-item" ref="posterContainer">
				<div style="font-size: 18px;color: #000;margin: 0 0 10px 0;">微信扫码支付</div>
				<div class="ewm flex-column-item">
					<div ref="qrcodeContainer1"></div>
				</div>
			</div>
		</el-dialog>
		<!-- 提示框 -->
		<!-- <Toast ref="toastRef"></Toast> -->
	</div>
</template>

<script>
	import {
		getMember,
		getMemberList,
		getMemberOrderLog,
		buyMemberOrder
	} from "@/api/common";
	import Utils from "@/jslibs/utils";
	import Breadcrumb from '../../components/Breadcrumb.vue'
	import Toast from '../../components/Toast.vue';
	import QRCode from 'qrcodejs2'; // 引入二维码库
	import {
		getMyCourse,
		getUser,
		EditUser,
		getMemberOrder
	} from '@/api/mine';
	export default {
		data() {
			return {
				showShare: false,
				pathList: [{
					title: '我的',
					path: '/mine'
				}, {
					title: '会员购买确认',
					path: ''
				}],
				wxPay: false,
				detail: '',
				payType: 1,
				loginUser: {
					member: {}
				},
				selectRule: false,
				vipPrice: 0
			}
		},
		components: {
			Toast,
			Breadcrumb
		},
		mounted() {
			if (Utils.getCookie('loginUser')) {
				this.loginUser = JSON.parse(Utils.getCookie('loginUser'))
			}
			this.getMember()
			// this.$nextTick(() => {
			// 	this.$refs.toastRef.openToast('账户余额不足')
			// 	// this.$refs.toastRef.openToast('交易状态异常，请重新发起订单')
			// 	// this.$refs.toastRef.openToast('交易已关闭')
			// 	// this.$refs.toastRef.openToast('所购会员信息已发送变化，请重新发起订单')
			// })
		},
		methods: {
			async buyClick() {
				let that = this
				if (!this.selectRule) {
					this.$message({
						message: "请阅读并同意以下内容《报名须知》以及《合同条款》",
						type: "warning"
					});
					return
				}
				let payParams = {
					member_uuid: this.$route.query.id,
					pay_type: this.payType
				}
				if (this.payType == 2) {
					payParams.platform = 2
				}
				const {
					status,
					data
				} = await buyMemberOrder(payParams);
				if (data.result) {
					if (that.payType == 1) {
						that.$message({
							message: "购买成功",
							type: "success"
						});
						setTimeout(() => {
							that.$router.push({
								path: '/mine'
							})
						}, 1000)
					}
					if (that.payType == 2) {
						that.showShare = true
						that.$nextTick(() => {
							that.$refs.qrcodeContainer1.innerHTML = '';

							that.qrCodeInstance = new QRCode(that.$refs.qrcodeContainer1, {
								text: data.result.code_url, // 二维码内容
								width: 268, // 宽度
								height: 268, // 高度
								colorDark: "#000000", // 二维码颜色
								colorLight: "#ffffff", // 背景色
								correctLevel: QRCode.CorrectLevel.H // 容错级别
							});
						})
						that.getMemberOrderFunc(data.result.order_id)
					}
				}
			},
			async getMemberOrderFunc(orderId) {
				const {
					status,
					data
				} = await getMemberOrder({
					id: orderId
				})
				if (data.result.status==2) {
					this.$message({
						message: "购买成功",
						type: "success"
					});
					setTimeout(() => {
						this.$router.push({
							path: '/mine'
						})
					}, 1000)
				}else{
					setTimeout(()=>{
						this.getMemberOrderFunc(orderId)
					},5000)
				}
			},
			async getMember() {
				const {
					status,
					data
				} = await getMember({
					uuid: this.$route.query.id
				});
				this.detail = data.result
				this.vipPrice = this.detail.price - this.loginUser.member.price
			}
		}
	}
</script>

<style lang="less" scoped>
	.shareBg {
		background-size: 100%;
		position: relative;

		.ewm {
			width: 298px;
			height: 298px;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			border-radius: 13px 13px 13px 13px;
			padding: 24px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.page {
		padding: 30px 133px 120px;

		.cont {
			margin: 30px 233px 0;
			border-top: 4px solid rgba(0, 167, 60, 0.24);

			.vipBg {
				margin: 20px 0;
				background: rgba(234, 207, 140, 0.12);
				border-radius: 13px 13px 13px 13px;
				padding: 30px 0;

				.name {
					margin-top: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 18px;
					color: #000000;
				}

				.pr {
					font-family: DINPro, DINPro;
					font-weight: bold;
					font-size: 16px;
					color: #00A73C;

					span {
						font-size: 22px;
					}
				}
			}

			.wbox {
				background: #FFFFFF;
				box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
				border-radius: 13px 13px 13px 13px;
				padding: 20px;
				margin: 20px 0;

				.tit {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 18px;
					color: #333333;
				}

				.gbox {
					background: #FAFBFC;
					border-radius: 13px 13px 13px 13px;
					padding: 10px 20px;
					margin: 20px 0;
				}

				.vipName {
					margin-left: 6px;
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 400;
					font-size: 16px;
					color: #D7B155;
				}
			}

			.botl {
				padding: 16px 0;
				border-bottom: 1px solid #EEEEEE;

				&:last-child {
					border-bottom: none;
				}
			}

			.t {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
			}

			.t1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 500;
				font-size: 16px;
				color: #333333;
			}

			.t2 {
				font-family: DINPro, DINPro;
				font-weight: 500;
				font-size: 16px;
				color: #333333;

				span {
					margin-left: 4px;
					font-family: DINPro, DINPro;
					font-weight: 500;
					font-size: 13px;
					color: #333333;
				}
			}

			.gold {
				color: #D7B155;
			}

			.tip {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;

				span {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 13px;
					color: #00A73C;
				}
			}

			.mt10 {
				margin-top: 10px;
			}

			.tip {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #999999;

				span {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 500;
					font-size: 13px;
					color: #00A73C;
				}
			}
		}

		.price {
			font-family: DINPro, DINPro;
			font-weight: bold;
			font-size: 22px;
			color: #00A73C;

			span {
				margin-left: 4px;
				font-family: DINPro, DINPro;
				font-weight: 400;
				font-size: 16px;
				color: #00A73C;
			}
		}

		.bottomFixed {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			background: #FFFFFF;
			box-shadow: 0px 3px 13px 0px rgba(0, 0, 0, 0.06);
			padding: 20px 356px;

			.t1 {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 400;
				font-size: 13px;
				color: #000000;
			}

			.login-btn {
				width: 276px;
				height: 50px;
				background: url('../../assets/images/login/loginbtn.png') no-repeat;
				background-size: 100% 100%;
				margin-top: 13px;
				display: flex;
				align-items: center;
				justify-content: center;

				.text {
					font-family: HONOR Sans CN, HONOR Sans CN;
					font-weight: 600;
					font-size: 16px;
					text-shadow: 2px 2px 3px rgba(0, 167, 60, 0.4), 1px 1px 1px rgba(255, 255, 255, 0.4);
					text-align: center;
					font-style: normal;
					text-transform: none;
					background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}
		}
	}

	::v-deep .el-dialog__title {
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 500;
		font-size: 20px;
		color: #000000;
	}

	.dialog {
		.money {
			margin: 10px 0;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #000000;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #00A73C;
			}
		}

		.subTime {
			white-space: nowrap;
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 18px;
			color: #666666;

			span {
				font-family: HONOR Sans CN, HONOR Sans CN;
				font-weight: 600;
				font-size: 18px;
				color: #000;
			}
		}

		.ewm {
			margin: 20px 0;
			width: 276px;
			height: 276px;
		}

		.tt {
			font-family: HONOR Sans CN, HONOR Sans CN;
			font-weight: 400;
			font-size: 16px;
			color: #999999;
		}
	}

	.wxbtn {
		margin-top: 20px;
		width: 360px;
		height: 51px;
		border-radius: 12px 12px 12px 12px;
		border: 2px solid rgba(127, 218, 76, .24);
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: HONOR Sans CN, HONOR Sans CN;
		font-weight: 400;
		font-size: 16px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		background: linear-gradient(51.355320293479146deg, #10B649 0%, #56D111 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}
</style>